module.exports = function() {
  return new Worker(__webpack_public_path__ + "1055e86c46a2b2c358eb.worker.js");
};